// @flow strict

import React from 'react';
import { useLanguageContext } from '~contexts/language-context';
import { createLinkPath } from '~utils/helpers/create-link-path';

import * as styles from './tags.module.less';

/**
 * Type of component properties
 */
type TagsProps = {
  tags: Array<string> | null,
};

/**
 * Render tags for blog post
 *
 * @param {TagsProps} props - component properties
 *
 * @returns {Node}
 */
export const Tags = ({ tags }: TagsProps) => {
  const { language } = useLanguageContext();

  // render nothing if there are not tags
  if (tags == null || tags.length === 0) {
    return null;
  }

  return (
    <div className={styles.tags}>
      {tags.map((tag) => {
        return (
          <a
            className={styles.tag}
            key={tag}
            href={`${createLinkPath({
              path: `/blog/search`,
              language,
            })}?tags=${tag}`}
          >
            {tag}
          </a>
        );
      })}
    </div>
  );
};
